import React, { useState } from 'react';
import { TextField, Button, Grid, Paper, Typography } from '@mui/material';

const FinancialForm = ({ onAddItem, type }) => {
  const [description, setDescription] = useState('');
  const [amount, setAmount] = useState('');
  const [party, setParty] = useState('');
  const [dueDate, setDueDate] = useState('');

  const isDebt = type === 'debt';
  const partyLabel = isDebt ? 'A quem devo (credor)' : 'De quem vou receber (devedor)';
  const title = isDebt ? 'Adicionar Nova Dívida' : 'Adicionar Novo Recebível';

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!description || !amount || !party || !dueDate) {
      alert("Por favor, preencha todos os campos.");
      return;
    }

    const newItem = {
      description: description,
      amount: parseFloat(amount),
      due_date: dueDate,
      [isDebt ? 'creditor' : 'debtor']: party
    };
    
    onAddItem(newItem);

    // Limpa o formulário após o envio
    setDescription('');
    setAmount('');
    setParty('');
    setDueDate('');
  };

  return (
    <Paper sx={{ p: 3, mb: 3, boxShadow: 3 }}>
      <Typography variant="h6" gutterBottom>{title}</Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField label="Descrição" value={description} onChange={e => setDescription(e.target.value)} fullWidth required />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField label="Valor" type="number" value={amount} onChange={e => setAmount(e.target.value)} fullWidth required />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField label={partyLabel} value={party} onChange={e => setParty(e.target.value)} fullWidth required />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} fullWidth required InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={12} md={1} sx={{ display: 'flex' }}>
            <Button type="submit" variant="contained" fullWidth>Salvar</Button>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default FinancialForm;